const dev = 'https://client.calizy.com';
//const stage = 'https://client.staging.calizy.com';
const stage = 'https://whispering-retreat-27080-672fbdef6898.herokuapp.com';
const isLocalHost = window.location.hostname === 'localhost';
const isLocalIpHost = window.location.hostname === '127.0.0.1';
const localHost = isLocalIpHost ? 'http://127.0.0.1:2300' : 'http://localhost:2300';
const isProd = window.location.hostname === 'client.calizy.com';

export const baseUrl = isLocalHost || isLocalIpHost ? localHost : isProd ? dev : stage;
